import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useContext } from "react";

import Label from "src/components/labels/Label";
import { FAQContext } from "src/context/FAQContext";
import { CheckList } from "src/newComponents/CheckList";
import MiniFAQsSPC from "src/newComponents/MiniFAQsSPC";
import ReviewsSPC from "src/pages/landing/components/ReviewsSPC";

const FeatureHighlights = () => {
  const { getContentForPage } = useContext(FAQContext);
  const miniFaqContent = getContentForPage("Free Account");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.75rem" }}>
      <Typography variant="h1" style={{ fontSize: "28px", textAlign: "center" }} sx={{ color: "#009d47" }}>
        Discover the best Pharmacy education platform for your exam revision and Foundation Training Year
      </Typography>

      <div style={{ textAlign: "center" }}>
        <Typography variant="h2" style={{ fontSize: "24px" }} sx={{ mb: 1 }}>
          Why Join Us?
        </Typography>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "2rem" }}>
          <Typography variant="h3" style={{ fontSize: "20px" }}>
            Start the Foundation Pharmacist Training Year and your GPhC exam revision the right way
          </Typography>
          <Typography variant="h3" style={{ fontSize: "20px" }}>
            Preview our interactive learning resources and platform
          </Typography>
        </div>
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <Typography variant="h3" style={{ fontSize: "16px" }}>
            Trainee Pharmacists:
          </Typography>

          <CheckList
            items={[
              "Preview Foundation Pharmacist Training Programme",
              "GPhC exam revision lessons",
              "Question Bank",
              "Priority access to live revision webinars",
            ]}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography variant="h3" style={{ fontSize: "16px" }}>
            Pharmacy Students
          </Typography>
          <Label color="default" sx={{ mt: 1 }}>
            Coming Soon
          </Label>

          <CheckList items={["Oriel support", "Situation Judgement", "Interview Prep"]} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography variant="h3" style={{ fontSize: "16px" }}>
            Pharmacists:
          </Typography>

          <CheckList items={["Designated Supervisor Programme"]} />
        </Grid>
      </Grid>

      <div>
        <Typography variant="h2" style={{ fontSize: "28px", textAlign: "center" }} sx={{ mb: 2 }}>
          Create your FREE account and start your Foundation Pharmacist Training Year journey today
        </Typography>

        <ReviewsSPC titleVariant="h4" />
      </div>

      <div>
        <MiniFAQsSPC topics={miniFaqContent} />
      </div>
    </div>
  );
};

export { FeatureHighlights };
